import React, {useState,useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual';
import {Loading,ItemsListDetailTable} from "@gull";
import { useParams } from "react-router-dom";
import axios from 'axios'
import swal from "sweetalert2"
import { devises_list } from "app/devises";

const useLoad = (id) => {
    const t = useTranslate();
    const [articleListInfo,setArticleListInfo]=useState({})
    const [customFields,setCustomFields]=useState([])
    const [customFieldsTo,setCustomFieldsTo]=useState([])
    const [reload,setReload]=useState(Date.now())
    const [liaisons,setLiaisons]=useState([])
    const [customInterface, setCustomInterface] = useState({})
    const [loadCustom,setLoadCustom] = useState(true)
    const [loadCustomTo,setLoadCustomTo] = useState(true)
    const [loadLiaison,setLoadLiaison] = useState(true)
    const [loadCustomInterface,setLoadCustomInterface] = useState(true)
    const [loadFinal,setLoadFinal] = useState(true)

    const [optionsDataTable,setOptionsDataTable]=useState({
        devise:[],
        marque:[],
        fournisseur:[],
        firstlevelcat:[],
        secondlevelcat:[],
        thirdlevelcat:[],
        fourthlevelcat:[],
        fifthlevelcat:[]

    })
    const [ourOptionsDataTable,setOurOptionsDataTable]=useState({
        devise:{},
        marque:{},
        fournisseur:{},
        firstlevelcat:{},
        secondlevelcat:{},
        thirdlevelcat:{},
        fourthlevelcat:{},
        fifthlevelcat:{}

    })
    useEffect(function () {
        (async function() {
            const response  = await axios.get(process.env.REACT_APP_API_URL+"api/wms/article_list/one/"+id,
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{
                    setArticleListInfo(response.data.data)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setLoadCustom(false)
        })()
    }, [reload])

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_fields/all/article"
            ).then((response) => {
                setCustomFields(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                swal.fire(t(messageError), "", "error");
            })
            setLoadCustomTo(false)
        })()
    }, [reload])

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_fields/all/to"
            ).then((response) => {
                setCustomFieldsTo(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                swal.fire(t(messageError), "", "error");
            })
            setLoadLiaison(false)
        })()
    }, [reload])

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/liaison"
            ).then((response) => {
                setLiaisons(response.data.datas)

                let arr = ['firstlevelcat','secondlevelcat','thirdlevelcat','fourthlevelcat','fifthlevelcat','fournisseur','marque']
                //on crée une zone de stockage temporaire des données avant de tout set
                let optionsDataTableTemp = optionsDataTable
                let ourOptionsDataTableTemp = ourOptionsDataTable
                
                //formatage des options du select dans le cell edit du datatable pour les devises
                let arrDevise=[]
                let objDeviseOur={}
                devises_list.map(value=>{
                    arrDevise.push({'value':value.name+" - "+value.code,'label':value.name+" - "+value.code})
                    objDeviseOur[value.name+" - "+value.code]=value.code
                })

                optionsDataTableTemp={...optionsDataTableTemp,devise:arrDevise}
                ourOptionsDataTableTemp={...ourOptionsDataTableTemp,devise:objDeviseOur}

                //formatage des options du select dans le cell edit du datatable pour le reste des colones
                arr.forEach(item=>{
                    let optionsArr = [{'value':t('emptyValue'),'label':t('emptyValue')}]
                    let ourOptionObj = {}

                    ourOptionObj[t('emptyValue')]=''
                    response.data.datas[item].map(value=>{
                        optionsArr.push({'value':value.name,'label':value.name})
                        ourOptionObj[value.name]=value.id
                    })

                    optionsDataTableTemp={...optionsDataTableTemp,[item]:optionsArr}
                    ourOptionsDataTableTemp={...ourOptionsDataTableTemp,[item]:ourOptionObj}
                })

                setOptionsDataTable(optionsDataTableTemp)
                setOurOptionsDataTable(ourOptionsDataTableTemp)
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
            setLoadCustomInterface(false)
        })()
    }, [reload])

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_interface/filtreArticle"
            ).then((response) => {
                setCustomInterface(response.data)
                setLoadFinal(false)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                swal.fire(t(messageError), "", "error");
                setLoadFinal(false)
            })
        })()
    }, [reload])
    
    return [loadCustom,loadCustomInterface,loadCustomTo,loadFinal,loadLiaison,articleListInfo,setArticleListInfo,customFields,customFieldsTo,optionsDataTable,ourOptionsDataTable,liaisons,customInterface,setCustomInterface,setReload]
} 

const DetailListeArticleErpPos = (props) => {
    const t = useTranslate();
    const { posid,id } = useParams();
    const [loadCustom,loadCustomInterface,loadCustomTo,loadFinal,loadLiaison,articleListInfo,setArticleListInfo,customFields,customFieldsTo,optionsDataTable,ourOptionsDataTable,liaisons,customInterface,setCustomInterface,setReload]=useLoad(id)

    if(loadCustom || loadCustomInterface || loadCustomTo || loadCustomTo || loadFinal || loadLiaison ){
        return (<Loading></Loading>);
    }

    return (<>
        <ItemsListDetailTable 
            articleListInfo={articleListInfo}
            setArticleListInfo={setArticleListInfo}
            customFields={customFields}
            customFieldsTo={customFieldsTo}
            optionsDataTable={optionsDataTable}
            ourOptionsDataTable={ourOptionsDataTable}
            convertIntoList={true}
            id={id}

            liaisons={liaisons}
            customInterface={customInterface}
            setCustomInterface={setCustomInterface}
            setReload={setReload}
            module={props.module}
            posid={posid}//posid sera renseingé que dans le cas où si le composant est appelé depuis le POS
        />
    </>
    );
}

export default DetailListeArticleErpPos;


